import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { GestureConfig } from '@angular/material';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CookieModule } from 'ngx-cookie';
import { ToastrModule } from 'ngx-toastr';
import { NgxUploaderModule } from 'ngx-uploader';
import { ScriptLoaderService } from './_services/script-loader.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { SubscribeDevicesDialog } from './theme/eacds/contents/add-devices.component';
import { OpenDialog } from './theme/eacds/devices/open-dialog.component';
import { ChangePassword } from './theme/layouts/header-nav/change-password.component';
import { LayoutModule } from './theme/layouts/layout.module';
import { Globals, SharedModule } from './theme/shared';
import { GlobalsFactory } from './theme/shared/helpers/globals';
import { ThemeRoutingModule } from './theme/theme-routing.module';
import { ThemeComponent } from './theme/theme.component';

@NgModule({
  bootstrap: [AppComponent],
  declarations: [ThemeComponent, AppComponent, OpenDialog, ChangePassword, SubscribeDevicesDialog],
  entryComponents: [OpenDialog, ChangePassword, SubscribeDevicesDialog],
  imports: [
    LayoutModule,
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      enableHtml: true,
      maxOpened: 5,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      progressBar: true,
      timeOut: 4000,
    }),
    AppRoutingModule,
    ThemeRoutingModule,
    AuthModule,
    SharedModule,
    NgbModule,
    CookieModule.forRoot(),
    NgxUploaderModule,
  ],
  providers: [
    Globals,
    ScriptLoaderService,
    { provide: LOCALE_ID, useValue: 'en-US' },
    {
      provide: APP_INITIALIZER,
      useFactory: GlobalsFactory,
      deps: [Globals],
      multi: true,
    },
    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
  ],
})
export class AppModule { }
